/**
 * TaskInlineAttachments
 *
 * Small "attach file / attach image" control for the inline editors (description + campaign setup
 * details). Collects raw File objects into parent state (no auto-upload); the editor uploads them
 * to S3 on Save and connects them to the task's attachedFiles / attachedImages.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Upload, Button, Tag } from 'antd';
import { PaperClipOutlined, PictureOutlined } from '@ant-design/icons';

const TaskInlineAttachments = ({ files, setFiles, images, setImages }) => {
  // beforeUpload returns false so antd doesn't upload — we just stash the File for save time.
  const collect = (setter) => (file) => {
    setter((prev) => [...prev, file]);
    return false;
  };
  const removeAt = (setter) => (index) => setter((prev) => prev.filter((_, i) => i !== index));

  return (
    <div className="task-inline-attachments">
      <div className="task-inline-attachments__buttons">
        <Upload multiple showUploadList={false} beforeUpload={collect(setFiles)}>
          <Button icon={<PaperClipOutlined />} className="task-inline-attachments__btn">
            Attach file
          </Button>
        </Upload>
        <Upload multiple accept="image/*" showUploadList={false} beforeUpload={collect(setImages)}>
          <Button icon={<PictureOutlined />} className="task-inline-attachments__btn">
            Attach image
          </Button>
        </Upload>
      </div>

      {(files.length > 0 || images.length > 0) && (
        <div className="task-inline-attachments__list">
          {files.map((file, i) => (
            <Tag
              key={`file-${i}`}
              closable
              onClose={() => removeAt(setFiles)(i)}
              icon={<PaperClipOutlined />}
            >
              {file.name}
            </Tag>
          ))}
          {images.map((file, i) => (
            <Tag
              key={`img-${i}`}
              closable
              onClose={() => removeAt(setImages)(i)}
              icon={<PictureOutlined />}
            >
              {file.name}
            </Tag>
          ))}
        </div>
      )}
    </div>
  );
};

TaskInlineAttachments.propTypes = {
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired,
  images: PropTypes.array.isRequired,
  setImages: PropTypes.func.isRequired,
};

export default TaskInlineAttachments;
